module.exports = __webpack_public_path__ + "img/fyt_p17.e14fd2aa.png";